import React from 'react'
import { ButtonLink } from 'stylist'
import { withRouter } from 'react-router-dom'

const RouteCompanyUsers = ({ company, history, match: { path }, ...props }) => (
  <ButtonLink marginLeft kind="standard" to={`${path}/new`}>
    New
  </ButtonLink>
)

export default withRouter(RouteCompanyUsers)



// WEBPACK FOOTER //
// ./src/routes/admin/companies/plans/index.js